module.exports = __webpack_public_path__ + "static/media/number2.31a9a993.webp";